import { usePortalAuthStore } from '../stores/portalAuthStore';
import { useIdleTimeout } from '../../../hooks/useIdleTimeout';
import { IconLock } from '@tabler/icons-react';
import { Overlay, Center, Stack, Text, Button, Paper, ThemeIcon } from '@mantine/core';

/**
 * Portal variant of the lock screen — same behaviour as the CRM guard.
 */
export function PortalIdleTimeoutGuard() {
  const isAuthenticated = usePortalAuthStore(s => s.isAuthenticated);
  const { locked, unlock } = useIdleTimeout(isAuthenticated);

  if (!locked) {
    return null;
  }

  return (
    <Overlay fixed backgroundOpacity={0.35} blur={12} zIndex={9999}>
      <Center h='100dvh'>
        <Paper shadow='xl' radius='lg' p='xl' w={380} style={{ textAlign: 'center' }}>
          <Stack align='center' gap='md'>
            <ThemeIcon size={64} radius='xl' variant='light' color='orange'>
              <IconLock size={32} />
            </ThemeIcon>

            <Text fw={700} size='xl'>
              Session Locked
            </Text>

            <Text c='dimmed' size='sm'>
              Your session has been locked due to inactivity.
              <br />
              Click the button below to continue working.
            </Text>

            <Button fullWidth size='md' mt='sm' onClick={unlock}>
              Unlock
            </Button>
          </Stack>
        </Paper>
      </Center>
    </Overlay>
  );
}
